import React from 'react';
import clsx from 'clsx';
import { Table } from 'semantic-ui-react';
import fields from '@/constants/fields';
import TableWrapper from '@/components/table/TableWrapper';
import VocabularyTableColumns from '../containers/VocabularyTableColumns';
import LookupVocabularyTableRows from './LookupVocabularyTableRows';
import LookupTableFooter from '../containers/LookupTableFooter';

const LookupVocabularyTable = ({
  lookupItems,
  lookupName,
  canEdit,
  className,
  errors,
  validationWarnings = [],
}) => {
  const showWarning = canEdit && validationWarnings.find((e) => (
    e.context.lookupName === lookupName && !e.context.lookupItemUUID && e.fields.includes(fields.NAME)));

  return (
    <div className={clsx('aridhia-vocabulary-container', className)}>
      <TableWrapper sticky celled className="aridhia-vocabulary-table">
        <Table.Header fullWidth>
          <VocabularyTableColumns
            canEdit={canEdit}
            lookupName={lookupName}
            errors={errors}
            validationWarnings={validationWarnings}
            showWarning={showWarning}
          />
        </Table.Header>
        <Table.Body>
          <LookupVocabularyTableRows
            lookupItems={lookupItems.options}
            canEdit={canEdit}
            validationWarnings={validationWarnings}
            showWarning={showWarning}
          />
        </Table.Body>
        {canEdit && (<LookupTableFooter colSpan={showWarning ? '5' : '4'} />)}
      </TableWrapper>
    </div>
  );
};

export default LookupVocabularyTable;
